import React from "react";
import LinearLoadingBar from "../common/LinearLoadingBar";
import logo from "../../assets/media/logos/logo-demo7.svg";
import logoTest from "../../assets/media/logos/atg-test-logo.svg";
import "../../styles/Backend/components/LoadingPage.css";

const LoadingPage = () => {
  const logoSrc =
    process.env.REACT_APP_URL_ENVIRONMENT === "production" ? logo : logoTest;

  return (
    <div className="loading-page_body">
      <div className="loading-page_content">
        <img src={logoSrc} alt="ATG Plus" className="loading-page_logo" />
        <LinearLoadingBar className="loading-page_bar" />
      </div>
    </div>
  );
};

export default LoadingPage;
